function FieldError({msg}) {
  return (
    <p className="okta-form-input-error o-form-input-error o-form-explain" role="alert">
      <span className="icon icon-16 error-16-small" role="img" aria-label="Error"></span>{msg}
    </p>
  );
}

export default FieldError;
